// constants for calculations
const QUEEN_OPTIONS = "Double, Queen, European Queen"
let atcPrice = 0
let atcPriceOri = 0
// populate all money
const populateMoney = () => {
    let renderedPrice
    if (bundleDiscount > 0) {
        renderedPrice = `<span class="Price--highlight u-h4">${currencySymbol + renderMoney(finalPrice)}</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">${currencySymbol + renderMoney(originalPrice)}</span>`
    } else {
        renderedPrice = currencySymbol + renderMoney(finalPrice)
    }
    if (currencySymbol != '$') {
        document.querySelectorAll('.ProductMeta__Price').forEach((price) => (price.innerHTML = renderedPrice))
        document.querySelectorAll('#sticky-atc .price-caption').forEach((price) => (price.innerHTML = renderedPrice))
        document.querySelector('.ProductBundle__AddToCart .ProductMeta__Price').innerHTML = currencySymbol + renderMoney(finalPrice)
    } else {
        document.querySelectorAll('.ProductMeta__Price .money').forEach((price) => (price.innerHTML = renderedPrice))
        document.querySelectorAll('#sticky-atc .money').forEach((price) => (price.innerHTML = renderedPrice))
        document.querySelector('.ProductBundle__AddToCart .ProductMeta__Price .money').innerHTML = currencySymbol + renderMoney(finalPrice)
    }
}
// rendering money according to currency
const renderMoney = (money) => {
    let priceRendered = Shopify.formatMoney(money)
    return priceRendered
}

// calculate discount
const calcDiscount = (amount) => {
    let total
    if (bundleDiscountType != 'd') {
        total = amount - amount * (bundleDiscount / 100)
    } else {
        total = (amount / 100 - eachDiscount) * 100
    }

    return total
}

// populate color label
const getLabel = (prodId, varId, handle) => {
    for (const bundle of metafieldVars) {
        if (bundle.id === handle) {
            for (const prod of bundle.products) {
                if (prod.id === parseInt(prodId)) {
                    let variants = prod.variants
                    for (const variant of variants) {
                        if (variant.id === varId) {
                            let labelRenderd = ''
                            if (variant.label != undefined) {
                                labelRenderd = `<span class=labelTag>${variant.label}</span>`
                            }
                            return labelRenderd
                        }
                    }
                }
            }
        }
    }
}

const isColorListed = (colorName) => {
    return colorsList.find((element) => element === colorName)
}
// encryption formatter
class xxv {
    constructor() {
        this._ccw = {
            a: 'e',
            b: 'f',
            c: 'g',
            d: 'h',
            e: 'i',
            f: 'j',
            g: 'k',
            h: 'l',
            i: 'm',
            j: 'n',
            k: 'o',
            l: 'p',
            m: 'q',
            n: 'r',
            o: 's',
            p: 't',
            q: 'u',
            r: 'v',
            s: 'w',
            t: 'x',
            u: 'y',
            v: 'z',
            w: 'a',
            x: 'b',
            y: 'c',
            z: 'd',
            A: 'E',
            B: 'F',
            C: 'G',
            D: 'H',
            E: 'I',
            F: 'J',
            G: 'K',
            H: 'L',
            I: 'M',
            J: 'N',
            K: 'O',
            L: 'P',
            M: 'Q',
            N: 'R',
            O: 'S',
            P: 'T',
            Q: 'U',
            R: 'V',
            S: 'W',
            T: 'X',
            U: 'Y',
            V: 'Z',
            W: 'A',
            X: 'B',
            Y: 'C',
            Z: 'D',
        }
    }
    ccw(c) {
        const r = Array.from(String(atob(c))),
            t = this._ccw
        return r
            .map(function (c) {
                return t[c] ? t[c] : c
            })
            .join('')
    }
}
class xxx {
    constructor() {
        this._ccw = { 1: 'a', 2: 'b', 3: 'c', 4: 'd', 5: 'e', 6: 'f', 7: 'g', 8: 'h', 9: 'i', 0: 'j' }
    }
    ccw(c) {
        const r = Array.from(String(atob(c))),
            t = this._ccw
        return r
            .map(function (c) {
                return t[c] ? t[c] : c
            })
            .join('')
    }
}
// end of encryption formatter
const imageLayered = (target=null,img=null, is_opt=false) => {
    let wrapper = document.querySelector('#MediaLayered')
    let fs = wrapper.querySelector('.fittedSheet')
    let dc = wrapper.querySelector('.duvetCover')
    let pc = wrapper.querySelector('.pillowCover')
    let pc2 = wrapper.querySelector('.pillowCover2')
    let bs = wrapper.querySelector('.bolsterCover')
    if(target && img){
        if (window.innerWidth < 768 && !is_opt) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }
        
        // if(window.innerWidth < 1024){
        //     $product_carousel.flickity('select', 0);
        // }
        switch (target) {
            case 'fs':
                fs.setAttribute('src', img)
                fs.classList.add('show')
                break
            case 'dc':
                dc.setAttribute('src', img)
                dc.classList.add('show')
                break
            case 'pc':
                pc.setAttribute('src', img)
                pc.classList.add('show')
                break
            case 'pc2':
                pc2.setAttribute('src', img)
                pc2.classList.add('show')
                break
            case 'bs':
                bs.setAttribute('src', img)
                bs.classList.add('show')
                break
        }
    } else {
        let optBundle = document.querySelectorAll('.ColorSwatch__bundle')
        optBundle.forEach((opt) => {
            if(opt.checked){
                const prodWrapper = opt.closest('.bundle-wrapper')
                let ph = prodWrapper.getAttribute('data-product-handle')
                let pil = document.querySelector('.pil-'+ph)
                let pilCode = pil.getAttribute('data-product-code')
                let pilItem = pil.querySelectorAll('.piLayer')
                let dvv = opt.getAttribute('data-variant-value')
                dvv = dvv.replace(' ','_')
                let pilImages = []
                pilItem.forEach((item) => {
                    let img = item.value
                    pilImages.push(img)
                })
                let li = pilImages.find(i => i.includes(dvv))
                switch (pilCode) {
                    case 'fs':
                        fs.setAttribute('src', li)
                        fs.classList.add('show')
                        break;
                    case 'dc':
                        dc.setAttribute('src', li)
                        dc.classList.add('show')
                        break;
                    case 'pc':
                        pc.setAttribute('src', li)
                        pc.classList.add('show')
                        break;
                }
            }
        })
    }
}
if (bundleImageBuilder) { imageLayered() }
window.onclick = (e) => {
    let el = e.target
    // color swatches function on on click event
    if (el.classList.contains('ColorSwatch__bundle')) {
        const prodWrapper = el.closest('.bundle-wrapper')
        const bundleInput = prodWrapper.querySelector('.product-bundle-input')
        const prevPrice = bundleInput.dataset.finalPrice
        const prevOrig = bundleInput.dataset.origPrice
        const imageWrapper = prodWrapper.querySelector('.ProductItem__Image')
        let productId = bundleInput.dataset.productId
        const label = prodWrapper.querySelector('.swatchLabel')
        const tagLabel = prodWrapper.querySelector('.tag-wrapper')
        const handle = prodWrapper.dataset.productHandle
        if (prodWrapper.classList.contains('isSiblings')) {
            productId = el.dataset.prodId
        }
        const productData = productBundles.filter((prod) => {
            return prod.id === parseInt(productId)
        })[0]
        // update product input data to the new variant data
        for (const variant of productData.variants) {
            if (variant.option1 === el.dataset.variantValue && variant.available) {
                if (variant.option2 === bundleSelectedSize || (variant.name.includes('Pillowcase') || variant.name.includes('Bolster')) || (variant.name.includes('Duvet Cover') && QUEEN_OPTIONS.includes(bundleSelectedSize) && QUEEN_OPTIONS.includes(variant.option2))) {
                    bundleInput.dataset.variantId = variant.id
                    bundleInput.dataset.finalPrice = calcDiscount(variant.price)
                    bundleInput.dataset.origPrice = variant.price
                    label.innerText = el.value
                    tagLabel.innerHTML = getLabel(productId, variant.id, handle)
                    if (variant.featured_image) {
                        imageWrapper.src = variant.featured_image.src
                    } else {
                        imageWrapper.src = productData.media.find(media => media.alt == variant.option1).src
                    }
                    finalPrice = finalPrice - prevPrice + calcDiscount(variant.price)
                    originalPrice = originalPrice - prevOrig + variant.price
                    populateMoney()
                    break
                }
            }
        }
        // layered image
        if (bundleImageBuilder) {
            let ph = prodWrapper.getAttribute('data-product-handle')
            let pil = document.querySelector('.pil-' + ph)
            let pilCode = pil.getAttribute('data-product-code')
            let pilItem = pil.querySelectorAll('.piLayer')
            let dvv = el.getAttribute('data-variant-value')
            dvv = dvv.replace(' ', '_')
            let pilImages = []
            pilItem.forEach((item) => {
                let img = item.value
                pilImages.push(img)
            })
            let li = pilImages.find((i) => i.includes(dvv))
            imageLayered(pilCode, li)
        }
        
    }

    // size option on click function
    if (el.classList.contains('Swatch__Radio')) {
        const bundleWrappers = document.querySelectorAll('.bundle-wrapper')
        finalPrice = 0
        originalPrice = 0

        bundleWrappers.forEach((bundle) => {
            let bundleParentInput = bundle.querySelector('.product-bundle-input')
            if (bundleParentInput) {
                let imageWrapper = bundle.querySelector('.ProductItem__Image')
                let bundleSwatch = bundle.querySelector('.swatchLabel')
                let tagLabel = bundle.querySelector('.tag-wrapper')
                let sizeLabel = bundle.querySelector('.selectedSize')
                let handle = bundle.dataset.productHandle
                let bundleId = bundleParentInput.dataset.productId // is product ID
                let isSiblings = bundle.classList.contains('isSiblings') ? true : false
                let currSize = el.value
                bundleSelectedSize = currSize
                let availableColors = ''
                let selectedVariant
                if (sizeLabel) {
                    if (sizeLabel.dataset.title.includes('Duvet Cover') && QUEEN_OPTIONS.includes(currSize)) {
                        sizeLabel.innerHTML = 'Queen'
                    } else {
                        sizeLabel.innerHTML = currSize
                    }
                }

                // list all available variant name color swatches based on the selected size variant
                for (const product of productBundles) {
                    if (product.id === parseInt(bundleId)) {
                        product.variants.map((variant) => {
                            if (((variant.option2 === currSize && variant.available) || (variant.name.includes('Duvet Cover') && QUEEN_OPTIONS.includes(currSize) && QUEEN_OPTIONS.includes(variant.option2))) && variant.available && isColorListed(variant.option1) != undefined) {
                                if (selectedVariant === undefined) {
                                    selectedVariant = variant
                                }
                                availableColors += variant.option1
                            }
                            if ((variant.name.includes('Pillowcase') || variant.name.includes('Bolster')) && variant.available && isColorListed(variant.option1) != undefined) {
                                // ignoring sizes for variant with name 'Pillowcase'
                                availableColors += variant.option1
                                if (selectedVariant === undefined) {
                                    selectedVariant = variant
                                }
                            }
                        })
                        break
                    }
                }
                // [FOR SIBLINGS] list all available variant name color swatches based on the selected size variant
                if (isSiblings) {
                    const siblingsSwatchFirst = bundle.querySelectorAll('.first-swatch-sibling') // select all first swatches of each sibling groups to get each group's product id
                    siblingsSwatchFirst.forEach((swatch) => {
                        let prodId = swatch.querySelector('input').dataset.prodId
                        for (const product of productBundles) {
                            if (product.id === parseInt(prodId)) {
                                product.variants.map((variant) => {
                                    if ((variant.option2 === currSize || (variant.name.includes('Duvet Cover') && QUEEN_OPTIONS.includes(currSize) && QUEEN_OPTIONS.includes(variant.option2))) && variant.available && isColorListed(variant.option1) != undefined) {
                                        if (selectedVariant === undefined) {
                                            // to select only first available variant and ignore others
                                            selectedVariant = variant
                                        }
                                        availableColors += variant.option1
                                    }
                                    // ignoring sizes for variant with name 'Pillowcase'
                                    if ((variant.name.includes('Pillowcase')  || variant.name.includes('Bolster')) && variant.available && isColorListed(variant.option1) != undefined) {
                                        availableColors += variant.option1
                                        if (selectedVariant === undefined) {
                                            selectedVariant = variant
                                        }
                                    }
                                })
                                break
                            }
                        }
                    })
                }
                // repopulate all color swatches based on the selected size variant
                bundle.querySelectorAll('.bundle-each-option').forEach((color) => {
                    let colorInput = color.querySelector('.ColorSwatch__bundle')
                    if (availableColors.includes(colorInput.value)) {
                        colorInput.removeAttribute('disabled')
                        // populate and checked first list of available variant
                        if (availableColors.indexOf(colorInput.value) == 0) {
                            colorInput.checked = true
                            bundleParentInput.dataset.finalPrice = calcDiscount(selectedVariant.price)
                            bundleParentInput.dataset.origPrice = selectedVariant.price
                            bundleParentInput.dataset.variantId = selectedVariant.id
                            bundleSwatch.innerText = colorInput.value
                            if (isSiblings) {
                                bundleId = colorInput.dataset.prodId // [FOR SIBILINGS] repopulate bundleId according to each swatch as possibility of different productId of each swatches
                            }
                            const productData = productBundles.filter((prod) => {
                                return prod.id === parseInt(bundle.querySelector('input').dataset.productId)
                            })[0]
                            tagLabel.innerHTML = getLabel(bundleId, selectedVariant.id, handle)
                            if (selectedVariant.featured_image) {
                                imageWrapper.src = selectedVariant.featured_image.src
                            } else {
                                imageWrapper.src = productData.media.find((media) => media.alt == selectedVariant.option1).src
                            }
                            finalPrice += calcDiscount(selectedVariant.price)
                            originalPrice += selectedVariant.price
                        } else {
                            colorInput.removeAttribute('checked')
                        }
                    } else {
                        colorInput.setAttribute('disabled', true)
                        colorInput.checked = false
                    }

                    // reset the product input data if there is no available variant
                    if (availableColors === '') {
                        bundleParentInput.dataset.variantId = ''
                        bundleParentInput.dataset.finalPrice = ''
                        bundleParentInput.dataset.origPrice = ''
                        bundleSwatch.innerText = ''
                    }
                })
            }
        })
        if (document.querySelectorAll('#ProductForm__Addons .Form__AddonCheckbox').length > 0) {
            updateAtcPrice(true)
        } else {
            populateMoney()
        }
        
    }
}

/** Set up ATC price */
    const updateAtcPrice = (parent) => {
      // reset the price of before selected option
      if (!parent) {
        finalPrice = finalPrice - atcPrice
        originalPrice = originalPrice - atcPrice
      }
      atcPrice = 0
      // Add the addon price
      document.querySelectorAll('#ProductForm__Addons .Form__AddonCheckbox:checked').forEach(addonItem => {
        atcPrice += Number(addonItem.dataset.price)
        
      })
      // render it to final bundle price calculation
      finalPrice = finalPrice + atcPrice
      originalPrice = originalPrice + atcPrice
      populateMoney()
    }
